import React from 'react';
import { Flex, Heading, Button } from 'rebass';
import { useSelector } from 'react-redux';
import getUserInfo from 'selectors/profile';
import { UserState } from 'types/global';
import { RECRUITER } from 'constants/index';
import Form from 'components/Form';
import Field from 'components/Field';
import ErrorMessage from 'components/ErrorMessage';
import { startEditProfileSubmit, resolveEditProfileSubmit } from '../actions';

const EditProfileForm: React.FC = (): JSX.Element => {
  const user = useSelector<any, UserState>(state => state.user);
  const initialValues = getUserInfo(user);
  return (
    <Form
      startSubmitAction={startEditProfileSubmit().type}
      resolveSubmitAction={resolveEditProfileSubmit().type}
      initialValues={initialValues}
    >
      {(formProps: any) => {
        const { submitting, submitError } = formProps;
        return (
          <Flex width="100%" flexDirection="column" alignItems="center" py={7}>
            {submitError && <ErrorMessage>{submitError}</ErrorMessage>}
            <Heading fontSize={['36px']} textAlign="center" mb={5}>
              Edit Your Profile
            </Heading>
            <Flex width="100%" flexDirection="column" alignItems="center" css="max-width: 400px">
              <Field name="companyName" label="Company Name" required labelAsterisk />
              <Field name="contactPerson" label="Contact Person" required labelAsterisk />
              <Field
                name="contactPersonTitle"
                label="Contact Person Title"
                required
                labelAsterisk
              />
              <Field name="phoneNumber" label="Phone Number" required labelAsterisk />
              {user.role === RECRUITER ? (
                <Field name="recruitingLicence" label="Recruiting Licence" required labelAsterisk />
              ) : (
                <Field name="companyBio" label="Company Bio" inputType="textarea" />
              )}
              <Field
                name="country"
                label="Country"
                inputType="select"
                selectOptions={['USA', 'Canada']}
                required
                labelAsterisk
              />
              <Field name="city" label="City" required labelAsterisk />
              <Field name="address" label="Address" required labelAsterisk />
              <Flex width="100%" justifyContent="space-between">
                <Field
                  name="province"
                  label="Province-State"
                  width="175px"
                  placeholder="BC"
                  pattern="[A-Z]{2}"
                  patternMismatch="Needs to be 2 capital letters"
                  required
                  labelAsterisk
                />
                <Field name="postalCode" label="Postal Code" width="175px" required labelAsterisk />
              </Flex>
              <Button
                type="submit"
                variant={submitting ? 'disabled' : 'primary'}
                mt={2}
                disabled={submitting}
              >
                Save
              </Button>
            </Flex>
          </Flex>
        );
      }}
    </Form>
  );
};

export default EditProfileForm;
